import { Badge } from "antd";
import React from "react";

interface CustomBadgeProps {
	children: React.ReactNode;
	status?: "success" | "processing" | "error" | "warning" | "default";
	color?: string;
}

function CustomBadge({ children, status, color }: CustomBadgeProps) {
	return status || color ? (
		<Badge
			status={status}
			color={color}
			text={children}
			style={{
				display: "flex",
				alignItems: "center",
				pointerEvents: "auto",
				color: "inherit",
			}}
		/>
	) : (
		children
	);
}

export default CustomBadge;
